const formatPercentages = (value: number | string, decimals: number = 2): string => {
    if (!value && value !== 0) {
        console.error('formatPercentages: Value is not defined');
        value = 0;
    }

    if (isNaN(+value)) {
        console.error('formatPercentages: Value is not a number');
        value = 0;
    }

    return parseFloat(value.toString()).toFixed(decimals);
};

export default formatPercentages;
